import './EditIntegrationModal.scss';

export { default } from './EditIntegrationModal';
